import { render, staticRenderFns } from "./ProductCategorySelect.vue?vue&type=template&id=5f21b24c&scoped=true"
import script from "./ProductCategorySelect.vue?vue&type=script&lang=js"
export * from "./ProductCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21b24c",
  null
  
)

export default component.exports